// @flow
import { LOAD_BIDDER_DATA_SUCCESS, LOG_OUT_BIDDER } from './user';
import { COMPLETE_ACCOUNT_SUCCESS } from './completeAccount';
import { CONFIRM_PASSWORD_SUCCESS } from './confirmPassword';
import { createSelector } from 'reselect';
import type { GlobalState } from '../rootReducer';
import { LOGIN_SUCCESS } from './login';
import { PASSWORD_RESET_SUCCESS } from './passwordReset';
import { UPDATE_ACCOUNT_SUCCESS } from './updateAccount';

/* reducer */
const DEFAULT_STATE = {
    stripeCustomer: {},
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOGIN_SUCCESS:
        case CONFIRM_PASSWORD_SUCCESS:
        case COMPLETE_ACCOUNT_SUCCESS:
        case PASSWORD_RESET_SUCCESS:
        case LOAD_BIDDER_DATA_SUCCESS:
        case UPDATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                stripeCustomer: action.payload.stripeCustomer,
            };
        case LOG_OUT_BIDDER:
            return DEFAULT_STATE;
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.stripe;

export const stripeCustomerSelector = createSelector(stateSelector, state => state.stripeCustomer);

export const getIsStripeCustomer = createSelector(stripeCustomerSelector, stripeCustomer => {
    if (stripeCustomer) {
        return Boolean(stripeCustomer.id) && !stripeCustomer.deleted;
    }
    return false;
});

const getSmallCardDetails = card => {
    // For some reason, the response for brand does not match the api docs so we need to transform amex and diners
    let brand = String(card.brand).toLowerCase();
    if (brand === 'american express') {
        brand = 'amex';
    } else if (brand === 'diners club') {
        brand = 'diners';
    }
    return {
        brand: brand,
        last4: card.last4,
        month: card.exp_month,
        name: card.name,
        token: card.id,
        year: card.exp_year,
    };
};

export const getStripeCreditCard = createSelector(
    [stripeCustomerSelector, getIsStripeCustomer],
    (stripeCustomer, isStripeCustomer) => {
        if (!isStripeCustomer) {
            return {};
        }
        const { default_source, sources } = stripeCustomer;
        const { data } = sources;

        if (sources.total_count === 1) {
            return getSmallCardDetails(data[0]);
        }

        const card = data.find(x => x.id === default_source) || {};
        return getSmallCardDetails(card);
    },
);
